import { BaseComponent } from '../../base-component';

export const ALTERNATIVE_URL_FRAGMENT = 'alternative';
export const VARIATION_LOAD_FAILED_EVENT = 'ft5.pdp.variation-load-failed';

export class RedirectMessageComponent extends BaseComponent {
    public rootSelector = '.js_pdp_redirect-message';
    private readonly showMessageListener;
    constructor() {
        super();
        this.showMessageListener = this.showMessage.bind(this);
    }
    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }

        this.handleSeoRedirect();
        this.addVariationLoadFailedListener();
    }

    private addVariationLoadFailedListener(): void {
        o_global.eventQBus.on(VARIATION_LOAD_FAILED_EVENT, this.showMessageListener);
    }

    private showMessage(): void {
        this.getRootElement().classList.remove('pl_hidden');
        o_global.eventQBus.off(VARIATION_LOAD_FAILED_EVENT, this.showMessageListener);
    }

    private handleSeoRedirect(): void {
        if (o_util.fragment.get(ALTERNATIVE_URL_FRAGMENT)) {
            this.showMessage();
            o_util.fragment.remove(ALTERNATIVE_URL_FRAGMENT);
        }
    }
}
